export var ControlPropertyType;
(function (ControlPropertyType) {
    ControlPropertyType["FontSize"] = "fontSize";
    ControlPropertyType["FontStyle"] = "fontStyle";
    ControlPropertyType["Color"] = "color";
    ControlPropertyType["LineSize"] = "lineSize";
    ControlPropertyType["LineStyle"] = "lineStyle";
    // VerticalAlign = 'verticalAlign',
    // HorizontalAlign = 'horizontalAlign',
    ControlPropertyType["Border"] = "border";
    ControlPropertyType["TextAlign"] = "textAlign";
})(ControlPropertyType || (ControlPropertyType = {}));
